import React, {Component} from 'react';
import { injectIntl } from 'react-intl'
import {Link} from "react-router-dom";
import {messages} from "../common/Translations";

const GalleryImage = ({galleryImage, onDelete, intl}) => {

    return (
        <div className="row">
            <div className="col-md-1"><i className="fa fa-arrows" /></div>
            <div className="col-md-1">{galleryImage.id}</div>
            <div className="col-md-2">
                <div>
                    <img width="100px" alt="Preview" src={`${galleryImage.filePath}?${(new Date()).getTime()}`} />
                </div>
            </div>
            <div className="col-md-6">{galleryImage.description}</div>
            <div className="col-md-2 text-right">
                <div className="btn-group" onMouseDown={e => e.stopPropagation()}>
                    <Link
                        to={`/galleri-billede/rediger/${galleryImage.galleryId}/${galleryImage.id}`}
                        className="btn btn-secondary waves-effect list-action"
                    >
                        <i className="fa fa-pencil"/> {intl.formatMessage(messages.listDropDownButtonEdit)}
                    </Link>
                    <button type="button" className="btn clickable btn-secondary dropdown-toggle dropdown-toggle-split"
                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <span className="sr-only">{intl.formatMessage(messages.listDropDownButtonOptions)}</span>
                    </button>
                    <div className="dropdown-menu">
                        <Link
                            to={`/galleri-billede/crop/${galleryImage.galleryId}/${galleryImage.id}`}
                            className="dropdown-item clickable"
                        >
                            <i className="fa fa-crop"/> Crop
                        </Link>
                        <Link
                            to={`/galleri-billede/rotate/${galleryImage.galleryId}/${galleryImage.id}`}
                            className="dropdown-item clickable"
                        >
                            <i className="fa fa-rotate-right"/> Rotate
                        </Link>
                        <button type="button"
                                className="dropdown-item clickable"
                                onClick={() => onDelete(galleryImage.id)}
                        >
                            <i className="fa fa-trash-o"/> {intl.formatMessage(messages.listDropDownButtonDelete)}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default injectIntl(GalleryImage);


// WEBPACK FOOTER //
// ./web/src/components/galleries/GalleryImage.jsx